module.exports = __webpack_public_path__ + "img/milpay-logo.ab0d90c7.svg";